"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeApiError = normalizeApiError;
exports.rejectWithNormalizedErr = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _errors = require("../../errors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function toViolation(item) {
  return {
    field: item.field,
    messages: item.lc_messages
  };
}

function toViolations(data) {
  if (!data) return;
  return data.map(toViolation);
}

function errFromString(message) {
  return new _errors.ApiError(400, message, 'Bad Request');
}

function normalizeApiError(res) {
  if (typeof res === 'string') return errFromString(res);
  var response = res && res.response ? res.response : res;
  var code = (0, _get2["default"])(response, 'body.error.code');
  var statusCode = Number((0, _get2["default"])(response, 'status')) || 400;
  var message = (0, _get2["default"])(response, 'body.error.type') || (0, _get2["default"])(response, 'body.error.lc_message') || (0, _get2["default"])(response, 'message') || 'Unknown Error';
  var violations = toViolations((0, _get2["default"])(response, 'body.error.violations.list'));
  return new _errors.ApiError(statusCode, message, code, violations);
}

var rejectWithNormalizedErr = function rejectWithNormalizedErr(res) {
  return Promise.reject(normalizeApiError(res));
};

exports.rejectWithNormalizedErr = rejectWithNormalizedErr;